export const AttendancePage: React.FC = () => (
  <section id="attendance" className="page-section">
    <div className="page-header">
      <div>
        <p className="page-eyebrow">Check-In</p>
        <h2 className="page-title">Attendance</h2>
        <p className="page-copy">Member check-in records and drawing eligibility.</p>
      </div>
    </div>
    <div className="placeholder-grid">
      <article className="placeholder-card">
        <h3>Live Scanner Feed</h3>
        <p>Connect scanner activity here to monitor in-person check-ins and late arrivals.</p>
      </article>
      <article className="placeholder-card">
        <h3>Eligibility Audit</h3>
        <p>Surface attendance-derived drawing eligibility and missing check-in exceptions.</p>
      </article>
    </div>
  </section>
);
